import React, { FC } from "react";
import { CircularProgress } from "@material-ui/core";

import ErrorBoundary from "../../basic/error_boundary";
import CourseContentContainer from "./container";

import "./styles.scss";

type Props = {
  isAuthorized: boolean;
};

const CourseContent: FC<Props> = (props: Props) => (
  <ErrorBoundary>
    <React.Suspense fallback={<CircularProgress />}>
      <CourseContentContainer {...props} />
    </React.Suspense>
  </ErrorBoundary>
);
export default CourseContent;
